// imports
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";

// styles
import "./App.css";
import Particles from "react-tsparticles";

// components
import Navbar from "./components/Navbar";

// pages
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";

function App() {
  const { authIsReady, user } = useAuthContext();

  // eslint-disable-next-line no-unused-vars
  const particlesInit = (main) => {
    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  };

  // eslint-disable-next-line no-unused-vars
  const particlesLoaded = (container) => {};

  return (
    <div className="App">
      {/* tsParticles */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: false,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 0.5,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 40,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />

      {/* Show when authIsReady */}
      {authIsReady && (
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={
                user ? (
                  <Navigate to="/myTodo" />
                ) : (
                  <Navigate to="/myTodo/login" />
                )
              }
            />
            <Route
              path="/myTodo"
              element={user ? <Home /> : <Navigate to="/myTodo/login" />}
            />
            <Route
              path="/myTodo/login"
              element={!user ? <Login /> : <Navigate to="/myTodo" />}
            />
            <Route
              path="/myTodo/signup"
              element={!user ? <Signup /> : <Navigate to="/myTodo" />}
            />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
